import React from 'react'
import Navbar from '../components/navbar/Navbar'
import Footer from '../components/footer/Footer'
import Contact from '../components/contact/Contact'

const ContactPage = () => {
  return (
    <div>
      <Navbar/>
      <Contact/>
      <Footer/>
    </div>
  )
}

export default ContactPage